import { Typography } from '@maistodos/design-system-web'

export const SectionTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Typography variant="large" color="neutral600" weight="bold">
    {children}
  </Typography>
)
